<template> 
  <div class="container">
    <img class="me" alt="Me" src="../assets/Untitled design (13).png" />
    
    <h1>
      <span class="light">MUHAMMAD </span>
      <span class="light">SAAD</span><br />
      <span class="light">MEHBOOB</span>
    </h1>

    <p>A Software Engineer who has developed countless innovative solutions.</p>

    <div class="socials-container">
      <a href="mailto:muhammadsaadmeh824@gmail.com" target="_blank">
        <img class="socials" alt="email" src="../assets/mail.png" />
      </a>
      <a href="https://www.linkedin.com/in/muhammad-saad-mehboob-125829247" target="_blank">
        <img class="socials" alt="linkedin" src="../assets/linkdin.png" />
      </a>
      <a href="https://x.com/MuhammadSa55160" target="_blank">
        <img class="socials" alt="twitter" src="../assets/twitter.png" />
      </a>
      <a href="https://www.instagram.com/saad_mehboob_" target="_blank">
        <img class="socials" alt="instagram" src="../assets/instagram.png" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeCard',
}
</script>

<style scoped>
.me {
  height: 250px;
}

.socials {
  height: 30px;
  transition: all 0.3s ease-in-out;
}

.socials:hover {
  filter: drop-shadow(0 0 6px #4dc3ff) brightness(1.3);
  transform: scale(1.1);
}

.socials-container {
  display: flex;
  gap: 20px;
}

.container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 300px;
  gap: 10px;
  background: white;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(255, 255, 255, 0.1);
}

h1 {
  font-size: 1.5rem;
  font-weight: 900;
  line-height: 1;
  margin-left: 0px;
}

.light {
  color: rgb(0, 0, 0);
}

.dark {
  color: #2860c9d5;
}
</style>
